import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/at-logo.svg";

interface BasicContainerProps {
  $backgroundColor?: string;
  $alignItems?: string;
  $padding?: [string, string, string];
  $height?: string;
}

export const BaseContainer = styled.div<BasicContainerProps>`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.$backgroundColor};
  padding: ${(props) => (props.$padding ? props.$padding[0] : "6rem 0 7rem 0")};
  align-items: ${(props) => props.$alignItems || "center"};
  height: ${(props) => props.$height || "auto"};

  @media (min-width: 768px) {
    padding: ${(props) =>
      props.$padding ? props.$padding[1] : "8rem 0 9rem 0"};
  }

  @media (min-width: 1024px) {
    padding: ${(props) =>
      props.$padding ? props.$padding[2] : "10rem 0 11rem 0"};
  }
`;

// New Big header
export const BigH1 = styled.h1`
  font-size: 26px;
  color: var(--maindark);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 1rem 0 1rem 0;

  @media screen and (min-width: 768px) {
    font-size: 28px;
    margin: 1rem 0 2rem 0;
  }

  @media screen and (min-width: 1024px) {
    font-size: 36px;
    margin: 1rem 0 2rem 0;
  }
`;

// New header above BigHeader
export const Headertop = styled.h3`
  font-size: 14px;
  font-weight: 300;
  color: var(--maindark);
  text-transform: uppercase;
  white-space: nowrap;
  letter-spacing: 1.7px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    font-size: 18px;
  }
`;

// New paragraph
interface StyledParagraphProps {
  $margin?: {
    mobile?: string;
    tablet?: string;
    desktop?: string;
  };
  $textAlign?: string;
}

export const MainParagraph = styled.p<StyledParagraphProps>`
  color: var(--darktext);
  font-weight: 300;
  font-size: 16px;
  text-align: ${(props) => props.$textAlign || "left"};
  margin: ${(props) => props.$margin?.mobile || "0"};
  line-height: 20px;
  max-width: 97%;
  white-space: pre-line;

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 26px;
    margin: ${(props) => props.$margin?.tablet || "0"};
    max-width: 90%;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 18px;
    line-height: 30px;
    margin: ${(props) => props.$margin?.desktop || "0"};
    max-width: 730px;
  }
`;

// Mainpage containers
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;

export const IngressContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 80px;
  width: 98%;
`;

interface InfoContainerProps {
  $alignItems?: string;
}
export const InfoContainer = styled.div<InfoContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${(props) => props.$alignItems || "flex-start;"};
  max-width: 800px;
  margin: 0 20px;

  /* Tablet  */
  @media (min-width: 768px) {
    margin: 0 50px;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    margin: 0 50px;
  }
`;

// Logo
interface LogoMiniProps {
  $isLandingPage?: boolean;
}

const SmallLogo = styled.img<LogoMiniProps>`
  align-self: flex-end;
  width: ${(props) => (props.$isLandingPage ? "40px" : "60px")};
  margin: 0;

  /* Tablet */
  @media (min-width: 768px) {
    width: ${(props) => (props.$isLandingPage ? "60px" : "70px")};
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: ${(props) => (props.$isLandingPage ? "70px" : "90px")};
  }
`;

// AndTech logo with- används i gamla footer, kan tas bort senare
export const LogoMini = (isLandingPage?: boolean) => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };

  return (
    <Link to="/" onClick={scrollToTop}>
      <SmallLogo $isLandingPage={isLandingPage} src={logo} alt="AndTech logo" />
    </Link>
  );
};

// Pink button
interface PinkButtonProps {
  $backgroundColor?: string;
}

export const PinkButton = styled.button<PinkButtonProps>`
  border-radius: 50px;
  border: 2px solid var(--maindark);
  background-color: ${(props) => props.$backgroundColor};
  color: var(--maindark);
  font-family: "safiromedium";
  font-size: 16px;
  width: 120px;
  height: 45px;
  margin-top: 40px;

  &:hover {
    background-color: var(--maindark);
    color: var(--mainlight);
  }
`;

export const IngressHeader = styled.h3`
  color: var(--darktext);
  font-size: 29px;
  text-transform: uppercase;
  line-height: 30px;
  margin-bottom: 18px;

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: 45px;
    margin-bottom: 0;
    line-height: 50px;
    width: 98%;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 30px;
    line-height: 70px;
  }
`;

export const BasicHeader = styled.h6`
  color: var(--darktext);
  font-family: "safiromedium";
  font-weight: normal;
  font-size: 18px;
  text-align: left;
  margin: 30px 0 -18px 0;
  text-transform: uppercase;
`;

interface BreadProps {
  $margin?: {
    mobile?: string;
    tablet?: string;
    desktop?: string;
  };
}

export const Bread = styled.p<BreadProps>`
  color: var(--darktext);
  font-weight: 200;
  font-size: 16px;
  text-align: left;
  margin: ${(props) => props.$margin?.mobile || "16px 0"};
  line-height: 20px;
  max-width: 97%;

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 26px;
    margin: ${(props) => props.$margin?.tablet || "20px 0"};
    align-items: center;
    max-width: 90%;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 22px;
    line-height: 30px;
    margin: ${(props) => props.$margin?.desktop || "20px 0"};
    max-width: 822px;
  }
`;

// Sliding Links with underline
interface LinkLineProps {
  $textColor?: string;
  $lineColor?: string;
  $fontSize?: string;
  $fontSizeTablet?: string;
  $fontSizeDesktop?: string;
  to?: string;
}

export const LinkLine = styled(Link)<LinkLineProps>`
  position: relative;
  font-family: "safiromedium";
  font-size: ${(props) => props.$fontSize || "18px"};
  color: ${(props) => props.$textColor || "var(--darktext)"};
  text-decoration: none;
  display: inline-block;
  margin: 5px 0;

  &:hover {
    color: ${(props) => props.$textColor || "var(--darktext)"};
  }

  &::after {
    content: "";
    position: absolute;
    display: inline-block;
    width: 0;
    height: 5px;
    bottom: -2px;
    left: 0;
    background-color: ${(props) => props.$lineColor || "var(--bg-pink)"};
    transform-origin: left;
    transition: width 0.5s ease;
  }

  &:hover::after {
    width: 100%;
  }

  /* Tablet  */
  @media (min-width: 768px) {
    font-size: ${(props) => props.$fontSizeTablet || "22px"};
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: ${(props) => props.$fontSizeDesktop || "28px"};
  }
`;

// Static links with underline
interface LinkProps {
  $textColor?: string;
  $lineColor?: string;
  $hoverLineColor?: string;
}

export const LinkStatic = styled.a<LinkProps>`
  color: ${(props) => props.$textColor || "var(--text)"};
  margin: 8px 0;
  font-weight: 300;
  font-size: 16px;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-thickness: 0.8px;
  text-decoration-color: ${(props) => props.$lineColor || "var(--text)"};

  &:hover {
    text-decoration-thickness: 4px;
    text-decoration-color: ${(props) =>
      props.$hoverLineColor || "var(--bg-pink)"};
  }
`;

export const IngreassParagraph = styled.p`
  color: var(--darktext);
  font-weight: 300;
  font-size: 17px;
  text-align: left;
  line-height: 27px;
  margin: 18px 0 70px 0;

  /* Tablet  */
  @media (min-width: 768px) {
    max-width: 600px;
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 1rem;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 22px;
    max-width: 800px;
    line-height: 28px;
    margin-bottom: 2rem;
  }
`;
